module.exports = __webpack_public_path__ + "img/48f14da4cab54fb5888f3a7de60ca9d8.cc6b4e45.png";